export default __webpack_public_path__ + "static/media/how-we-help-3.2a66c39f.svg";